/**
 * @deprecated use toMaskedPhoneNumber instead
 */
export const maskPhoneNumber = (digits: string) => toMaskedPhoneNumber(digits)

export const toMaskedPhoneNumber = (digits: string) => {
  const cleaned = cleanDialstring(digits)
  if (cleaned.startsWith('#') || cleaned.startsWith('*')) {
    return cleaned
  }
  if (cleaned.length > 10) return cleaned
  if (cleaned.length > 7) {
    return `(${cleaned.substring(0, 3)}) ${cleaned.substring(
      3,
      6,
    )}-${cleaned.substring(6)}`
  }
  if (cleaned.length > 4) {
    return `${cleaned.substring(0, 3)}-${cleaned.substring(3)}`
  }
  return cleaned
}

export const cleanDialstring = (phone: string) => {
  const hasPlusPrefix = phone.trim().startsWith('+')
  const cleaned = trimChar(phone.replace(/[^0-9*#,]+/g, ''), ',')
  if (!hasPlusPrefix) return cleaned
  return cleaned.startsWith('+') ? cleaned : `+${cleaned}`
}

export const DIAL_TERMINATOR = '#'

/**
 * `#` terminates a dial string, it is not part of a target. Desk phones consume
 * it locally as "done dialing, send it" and users type it into the softphone out
 * of the same habit, so everything from the first `#` on is dropped: `146#`
 * dials 146, and a leading `#` leaves nothing to dial (`''`).
 *
 * Returns `''` for anything with no dialable character left, which callers must
 * treat as "refuse to dial". Never let a `#` reach a SIP request URI: the switch
 * has no `#` namespace to route to, so `sip:%23146@…` is accepted with a 202 and
 * then silently dropped.
 *
 * `*` and `,` are left alone. Both are routing-significant (star codes, DTMF
 * pauses) and valid unescaped in a SIP user part.
 */
export const toDialTarget = (phone: string): string => {
  const cleaned = cleanDialstring(phone)
  const terminator = cleaned.indexOf(DIAL_TERMINATOR)
  const target = trimChar(
    terminator === -1 ? cleaned : cleaned.slice(0, terminator),
    ',',
  )
  // A bare `+` or `,` survives the trim above but is not a dialable target.
  return /[0-9*]/.test(target) ? target : ''
}

const trimChar = (str: string, ch: string): string => {
  let start = 0
  let end = str.length
  while (start < end && str[start] === ch) start++
  while (end > start && str[end - 1] === ch) end--
  return str.slice(start, end)
}
